module.exports = function (imageSizes) {
  return function convertImgToPicture(md) {
    const defaultRender =
      md.renderer.rules.image ||
      function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options);
      };

    md.renderer.rules.image = function (tokens, idx, options, env, self) {
      const token = tokens[idx];
      const attrs = new Map(tokens[idx].attrs || []);
      const src = attrs.get('src') || '';
      if (
        token.tag !== 'img' ||
        (!src.includes('.googleusercontent.com') && !src.includes('ds7zuo2xqlq9a.cloudfront.net'))
      ) {
        return defaultRender(tokens, idx, options, env, self);
      }
      if (src.includes('.googleusercontent.com') && src.slice(-6) === '#video') {
        // Gif Animation
        const staticImg = src.includes('=') ? `${src.slice(0, -6)}-k` : `${src.slice(0, -6)}=k`;
        const mp4 = src.includes('=') ? `${src.slice(0, -6)}-rh` : `${src.slice(0, -6)}=rh`;
        return `
        <video autoplay loop muted playsinline controls poster="${staticImg}">
          <noscript class="loading-lazy">
            <source src="${mp4}" type="video/mp4" />
          </noscript>
        </video>`;
      }

      // Image
      const webp = src.includes('=') ? `${src}-rw` : `${src}=rw`;
      const size = imageSizes[src];

      if (size && 'width' in size && 'height' in size) {
        token.attrs.push(['width', size.width]);
        token.attrs.push(['height', size.height]);
      }

      token.attrs.push(['loading', 'lazy']);
      token.attrs.push(['style', 'height: auto; background-color:#f2f2f2;']);

      // NOTE: 透過画像は領域表示用の背景色が見えてしまうので、画像読み込み後に背景色を消す
      token.attrs.push(['onload', 'this.style.backgroundColor="transparent";']);

      return `
        <picture>
            <source type="image/webp" srcset="${webp}">
            ${defaultRender(tokens, idx, options, env, self)}
        </picture>`;
    };
  };
};
